export class GMonResultsAvailableMessage {
  public areVoltageResultsAvaiable: boolean;
  public areFrequencyResultsAvaiable: boolean;
  public voltageViolationsPerGridelementId: Map<number, number>;
  public frequencyViolationsPerGridelementId: Map<number, number>;
  public topologyId: string;
  public gridplanningScenarioId: number;
  public numberOfDaysRequestedByUser: number;
}

export class PVResultsAvailableMessage {
  public arePVResultsAvaiable: boolean;
}

export class LAResultsAvailableMessage {
  public laDays: number;
  public areNodeResultsAvaiable: boolean;
  public areCableResultsAvaiable: boolean;
  public nodeViolationsPerGridelementId: Map<number, number>;
  public cableViolationsPerGridelementId: Map<number, number>;
  public topologyId: string;
  public numberOfDaysRequestedByUser: number;
  public gridplanningScenarioId: number;
}

export class RPAResultsAvailableMessage {
  public rpaDays: number;
  public isDataAvaiable: boolean;
  public nodeViolationsPerGridelementId: Map<number, number>;
  public topologyId: string;
  public numberOfDaysRequestedByUser: number;
}


export class GPResultsAvailableMessage {
  public gMonGUIColoringInfoDto: GMonResultsAvailableMessage;
  public laGuiColoringInfoDto: LAResultsAvailableMessage;
}

export class LMResultsAvailableMessage {
  public gMonGUIColoringInfoDto: GMonResultsAvailableMessage;
  public laGuiColoringInfoDto: LAResultsAvailableMessage;
}

export class ApplicationProgressMessage {
  public type: MessageType;
  public timestamp: string;
  public message_en: string;
  public message_de: string;
}

export enum MessageType {
  GMON = "gmon",
  LA = "la",
  RPA = "rpa",
  LC = "lc",
  GPLAN = "gp"
}
